export const Links = [
	{
		name: 'Inicio',
		path: '/'
	},

	{
		name: 'Sobre Nosotros',
		path: '/about'
	},

	{
		name: 'Productos',
		path: '/products'
	},

	{
		name: 'Ubicación',
		path: '/Location'
	}
];
